import React from 'react';
import styled from '@emotion/styled';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
  children: React.ReactNode;
}

const Button = ({ onClick, children, ...rest }: ButtonProps) => {
  return (
    <CustomButton type='button' onClick={onClick} {...rest}>
      {children}
    </CustomButton>
  );
};

const CustomButton = styled.button`
  position: relative;
  display: inline-block;
  cursor: pointer;
  outline: none;
  border: 0;
  vertical-align: middle;
  text-decoration: none;
  font-size: 20px;

  color: white;
  text-transform: uppercase;
  padding: 1.1em 2em;
  background: #5768fc 0% 0% no-repeat padding-box;
  border: 2px solid #ffffff;
  transform-style: preserve-3d;
  transition: transform 150ms cubic-bezier(0, 0, 0.58, 1);

  width: 210px;
  height: 68px;

  &:hover {
    font-weight: 600;
    background: white;
    color: #5768fc;
    transform: translate(3px, 0.15em);
    &::before {
      background-color: #5768fb;
      box-shadow: 0 0 0 2px #ffffff;
      transform: translate3d(-3px, 0.35em, -1em);
    }
  }

  :active {
    font-weight: 600;
    background: white;
    transform: translate(8px, 0.5em);
    &::before {
      box-shadow: 0 0 0 2px #ffffff;
      transform: translate3d(-8px, 0, -1em);
    }
  }

  ::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0px;
    left: 10px;
    right: 0;
    bottom: 0;
    background: #3446dd 0% 0% no-repeat padding-box;
    box-shadow: 0 0 0 2px #ffffff;
    transform: translate3d(0, 0.5em, -1em);
    transition: transform 150ms cubic-bezier(0, 0, 0.58, 1),
      box-shadow 150ms cubic-bezier(0, 0, 0.58, 1);
  }
`;

// #5768FC

export default Button;
